import * as firebase from 'firebase/app';
import 'firebase/auth';
import React, { FC, useState } from 'react';
import { RouteComponentProps } from 'react-router-dom';
import styled from 'styled-components';
import Button from '../components/common/Button';

const LoginStyled = styled.div`
  width: 100vw;
  height: 100vh;
  display: flex;
  justify-content: center;
  align-items: center;
  background-color: #18191f;

  > div.wrapper {
    display: flex;
    flex-direction: column;
    flex: 0 1 300px;
    margin: 0px 16px;
    > div.icon-container {
      text-align: center;
      margin-bottom: 32px;
    }
    > input:not(:last-child) {
      margin-bottom: 8px;
    }
  }
`;

const InputStyled = styled.input`
  border-radius: 3px;
  border: none;
  height: 40px;
  font-size: 12px;
  padding-left: 8px;
  color: #1c1c1c;

  ::placeholder {
    opacity: 0.7;
  }
`;

const Login: FC<RouteComponentProps> = ({ history }) => {
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [isLoading, setIsLoading] = useState(false);

  const submitLogin = () => {
    setIsLoading(true);
    firebase.auth().signInWithEmailAndPassword(email, password)
      .then(() => {
        setIsLoading(false);
        history.replace('/');
      })
      .catch(() => {
        setIsLoading(false);
        alert('Could not login.');
      });
  };

  return (
    <LoginStyled>
      <div className="wrapper">
        <div className="icon-container">
          <svg width="188" height="209" viewBox="0 0 188 209" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path fillRule="evenodd" clipRule="evenodd" d="M94 156.347C58.5333 156.347 30.16 127.467 30.16 92C30.16 56.5333 58.5333 27.6533 94 27.6533C127.947 27.6533 155.813 52.9867 158.853 86.4267H129.467C128.24 77.9233 123.968 70.1544 117.445 64.5632C110.922 58.972 102.591 55.9386 94 56.0267H74.7467V66.16H95.0133C100.431 66.2417 105.667 68.1305 109.889 71.5268C114.112 74.923 117.079 79.632 118.32 84.9067H49.4133V95.04H118.32C117.811 101.133 115.025 106.81 110.518 110.941C106.011 115.072 100.114 117.355 94 117.333H74.7467V127.467H95.0133C112.747 127.467 127.44 114.8 130.48 97.0667H158.853C155.813 130.507 128.453 156.347 94.5067 156.347H94ZM94 16C53.4667 16 18 49.9467 18 92C18 134.053 52.4533 168 94 168C135.547 168 170 134.053 170 92C170 49.9467 137.067 16 94 16Z" fill="white" />
            <path d="M68.925 190C68.869 190 68.827 189.981 68.799 189.944C68.771 189.897 68.771 189.837 68.799 189.762L72.425 179.808C72.453 179.733 72.4856 179.682 72.523 179.654C72.5603 179.626 72.621 179.612 72.705 179.612H73.797C73.9743 179.612 74.0816 179.682 74.119 179.822L77.703 189.762L77.717 189.832C77.717 189.944 77.6656 190 77.563 190H76.569C76.457 190 76.3823 189.953 76.345 189.86L75.379 187.144C75.3603 187.107 75.3416 187.079 75.323 187.06C75.3043 187.041 75.267 187.032 75.211 187.032H71.137C71.053 187.032 70.997 187.069 70.969 187.144L69.975 189.874C69.947 189.958 69.877 190 69.765 190H68.925ZM74.847 185.968C74.9496 185.968 74.987 185.907 74.959 185.786L73.279 181.18C73.251 181.096 73.2183 181.054 73.181 181.054C73.1436 181.054 73.111 181.096 73.083 181.18L71.375 185.814L71.347 185.898C71.347 185.945 71.3843 185.968 71.459 185.968H74.847ZM83.8153 190.14C82.9286 190.14 82.1586 189.93 81.5053 189.51C80.8519 189.081 80.3479 188.469 79.9933 187.676C79.6479 186.883 79.4753 185.94 79.4753 184.848C79.4753 183.737 79.6526 182.776 80.0073 181.964C80.3713 181.152 80.8846 180.536 81.5473 180.116C82.2099 179.687 82.9846 179.472 83.8713 179.472C84.5059 179.472 85.0986 179.603 85.6493 179.864C86.2093 180.125 86.6666 180.471 87.0213 180.9C87.3853 181.329 87.6046 181.787 87.6793 182.272V182.356C87.6793 182.393 87.6699 182.421 87.6513 182.44C87.6419 182.459 87.6139 182.477 87.5673 182.496L86.5593 182.65H86.5313C86.4753 182.65 86.4333 182.603 86.4053 182.51C86.3026 181.941 86.0179 181.465 85.5513 181.082C85.0846 180.69 84.5199 180.494 83.8573 180.494C82.8959 180.494 82.1586 180.858 81.6453 181.586C81.1319 182.314 80.8753 183.373 80.8753 184.764C80.8753 186.22 81.1319 187.312 81.6453 188.04C82.1586 188.759 82.9053 189.118 83.8853 189.118C84.4546 189.118 84.9446 188.992 85.3553 188.74C85.7659 188.488 86.0739 188.166 86.2793 187.774C86.4939 187.382 86.6153 186.985 86.6433 186.584V185.744V185.716C86.6433 185.632 86.5966 185.59 86.5033 185.59H84.2213C84.1186 185.59 84.0673 185.543 84.0673 185.45V184.848C84.0673 184.764 84.1139 184.722 84.2073 184.722L87.6793 184.736C87.8193 184.736 87.8893 184.792 87.8893 184.904V189.818C87.8893 189.939 87.8333 190 87.7213 190H87.3993C87.3246 190 87.2686 189.991 87.2313 189.972C87.1939 189.953 87.1659 189.907 87.1473 189.832L86.9933 188.53C86.9839 188.493 86.9653 188.474 86.9373 188.474C86.9186 188.474 86.8953 188.497 86.8673 188.544C86.5686 189.02 86.1673 189.407 85.6633 189.706C85.1686 189.995 84.5526 190.14 83.8153 190.14ZM91.1129 179.808C91.1129 179.733 91.1222 179.682 91.1409 179.654C91.1689 179.626 91.2155 179.612 91.2809 179.612H97.5669C97.6602 179.612 97.7069 179.663 97.7069 179.766V180.48C97.7069 180.592 97.6462 180.648 97.5249 180.648H92.6389C92.5642 180.648 92.5129 180.662 92.4849 180.69C92.4662 180.709 92.4569 180.751 92.4569 180.816V184.092C92.4569 184.195 92.5082 184.246 92.6109 184.246H96.2369C96.3395 184.246 96.3909 184.297 96.3909 184.4V185.142C96.3909 185.226 96.3395 185.268 96.2369 185.268H92.6109C92.5082 185.268 92.4569 185.319 92.4569 185.422V188.824C92.4569 188.88 92.4662 188.917 92.4849 188.936C92.5035 188.955 92.5409 188.964 92.5969 188.964H97.7349C97.7909 188.964 97.8282 188.973 97.8469 188.992C97.8749 189.011 97.8889 189.048 97.8889 189.104V189.846C97.8889 189.949 97.8376 190 97.7349 190H91.3089C91.2342 190 91.1829 189.986 91.1549 189.958C91.1269 189.93 91.1129 189.879 91.1129 189.804V179.808ZM108.472 179.612C108.528 179.612 108.565 179.626 108.584 179.654C108.612 179.673 108.626 179.715 108.626 179.78V189.832C108.626 189.944 108.565 190 108.444 190H107.758C107.683 190 107.623 189.995 107.576 189.986C107.539 189.967 107.501 189.935 107.464 189.888L102.06 182.034C102.023 181.969 101.985 181.941 101.948 181.95C101.92 181.959 101.906 181.992 101.906 182.048V189.818C101.906 189.939 101.841 190 101.71 190H100.926C100.805 190 100.744 189.939 100.744 189.818V179.808C100.744 179.733 100.753 179.682 100.772 179.654C100.8 179.626 100.851 179.612 100.926 179.612H101.724C101.799 179.612 101.855 179.621 101.892 179.64C101.929 179.659 101.971 179.696 102.018 179.752L107.268 187.438C107.315 187.494 107.357 187.522 107.394 187.522C107.45 187.522 107.478 187.48 107.478 187.396V179.78C107.478 179.668 107.534 179.612 107.646 179.612H108.472ZM111.41 179.766C111.41 179.663 111.466 179.612 111.578 179.612H119.11C119.222 179.612 119.278 179.663 119.278 179.766V180.494C119.278 180.55 119.264 180.587 119.236 180.606C119.208 180.625 119.166 180.634 119.11 180.634H116.268C116.212 180.634 116.17 180.643 116.142 180.662C116.123 180.681 116.114 180.718 116.114 180.774V189.818C116.114 189.939 116.058 190 115.946 190H114.938C114.826 190 114.77 189.939 114.77 189.818V180.788C114.77 180.723 114.76 180.681 114.742 180.662C114.723 180.643 114.686 180.634 114.63 180.634H111.578C111.522 180.634 111.48 180.625 111.452 180.606C111.424 180.587 111.41 180.55 111.41 180.494V179.766Z" fill="white" />
          </svg>
        </div>
        <InputStyled
          type="email"
          placeholder="Email"
          value={email}
          onChange={(e) => setEmail(e.target.value)}
        />
        <InputStyled
          type="password"
          placeholder="Password"
          value={password}
          onChange={(e) => setPassword(e.target.value)}
          onKeyUp={(e) => {
            if (e.key === 'Enter') {
              submitLogin();
            }
          }}
        />
        <Button
          onClick={submitLogin}
          isLoading={isLoading}
        >
          Login
        </Button>
      </div>
    </LoginStyled>
  );

};

export default Login;
